import { environment } from '../../environments';
import { LogoImage } from '../../types';

export const getPartnerKey = (): string | undefined => {
  if (window.PARTNER?.partnerKey) {
    return window?.PARTNER?.partnerKey;
  }

  if (environment.partnerKey) {
    return environment.partnerKey;
  }

  return undefined;
};

export const getWhitelabelDomain = (): string | undefined =>
  window.PARTNER?.whitelabelDomain || undefined;

export const getWhitelabelLogo = (): LogoImage | undefined =>
  window.PARTNER?.logo || window.PARTNER?.logoMobile || undefined;

export const getWhitelabelName = (): string | undefined => window.PARTNER?.name || 'LT';

export const getIsWhitelabel = (): boolean => !!window.PARTNER && window.PARTNER.name !== 'LT';
